module.exports = __webpack_public_path__ + "./fonts/4fcf4ed0e53a0e530c594edc6b7424ec.woff";